import { useSnackbar } from "notistack";
import { useReact_useEffect_Z101E1A95, useReact_useButtonRef, useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.1.68.0/React.fs.js";
import { Deferred$1, useFeliz_React__React_useDeferred_Static_2344FC52 } from "../fable_modules/Feliz.UseDeferred.1.5.0/UseDeferred.fs.js";
import { PagingQuery } from "../../../shared/Paging.fs.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.17/Async.js";
import { singleton } from "../fable_modules/fable-library.3.7.17/AsyncBuilder.js";
import { EnqueueSnackbarOption, SnackbarProp_Variant_Z609E1E86, ProviderContext__enqueueSnackbar_Z1776A768 } from "../../../Notistack/Notistack.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.17/Choice.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library.3.7.17/List.js";
import { Page$2__toUrl_2B594 } from "../../../BidirectionalRouting/BidirectionalRouting.fs.js";
import { customerDetail, epcCreateFromSibling, dossierCreateFromSibling, dossierDetail } from "../AppRoutes.fs.js";
import { map } from "../fable_modules/fable-library.3.7.17/Option.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogContent from "@material-ui/core/DialogContent";
import { Interop_reactApi } from "../fable_modules/Feliz.1.68.0/./Interop.fs.js";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import { createElement } from "react";
import { CreateDossierStepperPage } from "../../../DesignSystems/dossier/DossierCreate.fs.js";
import { printf, toConsole } from "../fable_modules/fable-library.3.7.17/String.js";
import { Compensation_get_DefaultCompensation, DossierKind } from "../../../shared/Domain.fs.js";
import { DossierCreatePageSource } from "../../../DesignSystems/DossierUtils.fs.js";
import { createObj } from "../fable_modules/fable-library.3.7.17/Util.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Page } from "../components/Page.fs.js";

export function DossierCreate(dossierCreateInputProps) {
    let elements_2, children, children_1, elems_3;
    const siblingSourceCode = dossierCreateInputProps.siblingSourceCode;
    const kind = dossierCreateInputProps.kind;
    const api = dossierCreateInputProps.api;
    const currentPage = dossierCreateInputProps.currentPage;
    const snackbar = useSnackbar();
    const patternInput = useFeliz_React__React_useState_Static_1505(void 0);
    const setCustomer = patternInput[1];
    const pageNumber = useFeliz_React__React_useState_Static_1505(0)[0] | 0;
    const pageSize = useFeliz_React__React_useState_Static_1505(2147483647)[0] | 0;
    const buttonRef = useReact_useButtonRef();
    const customers = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetCustomers(new PagingQuery(0, 2147483647), void 0), []);
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(void 0);
    const setCrossCreate = patternInput_3[1];
    const crossCreate = patternInput_3[0];
    const patternInput_4 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_5 = useFeliz_React__React_useState_Static_1505(void 0);
    const setPartnerId = patternInput_5[1];
    const partnerId = patternInput_5[0];
    const patternInput_6 = useFeliz_React__React_useState_Static_1505(new Deferred$1(0));
    const setPrefill = patternInput_6[1];
    useReact_useEffect_Z101E1A95(() => {
        startImmediate(singleton.Delay(() => singleton.Bind(api.GetPartnersAndSyndics(new PagingQuery(pageNumber, pageSize), void 0), (_arg_1) => {
            const partners_1 = _arg_1;
            if (partners_1.tag === 1) {
                const err_1 = partners_1.fields[0];
                console.error(err_1);
                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_1}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                return singleton.Zero();
            }
            else {
                patternInput_4[1](partners_1.fields[0].Data);
                return singleton.Zero();
            }
        })));
    }, [pageNumber, pageSize]);
    useReact_useEffect_Z101E1A95(() => {
        startImmediate(singleton.Delay(() => {
            if (partnerId == null) {
                return singleton.Zero();
            }
            else {
                const partnerId_1 = partnerId;
                return singleton.Bind(api.GetCustomerOfPartner(partnerId_1), (_arg_2) => {
                    const customer_3 = _arg_2;
                    if (customer_3.tag === 1) {
                        const err_2 = customer_3.fields[0];
                        return singleton.Combine((err_2.indexOf("Krijg klant") >= 0) ? ((ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Klantrecord niet gevonden voor deze partner. Klik op \u0027Partnerportaal activeren\u0027 op de partnerdetailpagina om er een aan te maken en probeer het vervolgens opnieuw.", SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false)), singleton.Zero())) : ((ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_2}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false)), (singleton.Zero()))), singleton.Delay(() => {
                            return singleton.Zero();
                        }));
                    }
                    else {
                        setCustomer(customer_3.fields[0]);
                        return singleton.Zero();
                    }
                });
            }
        }));
    }, [partnerId]);
    useReact_useEffect_Z101E1A95(() => {
        if (siblingSourceCode != null) {
            const sourceCode = siblingSourceCode;
            startImmediate(singleton.Delay(() => {
                setPrefill(new Deferred$1(1));
                return singleton.TryWith(singleton.Delay(() => singleton.Bind(api.GetSiblingDossierDraft(sourceCode, kind), (_arg_7) => {
                    const result_2 = _arg_7;
                    if (result_2.tag === 1) {
                        const err_5 = result_2.fields[0];
                        console.error(err_5);
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Kon gekoppeld dossier niet voorbereiden: ${err_5}`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                        setPrefill(new Deferred$1(2, new FSharpResult$2(1, err_5)));
                        return singleton.Zero();
                    }
                    else {
                        const partner = result_2.fields[0][2];
                        setCustomer(result_2.fields[0][1]);
                        return singleton.Combine((partner == null) ? ((singleton.Zero())) : ((setPartnerId(partner.Id), singleton.Zero())), singleton.Delay(() => {
                            setPrefill(new Deferred$1(2, new FSharpResult$2(0, result_2.fields[0])));
                            return singleton.Zero();
                        }));
                    }
                })), (_arg_8) => {
                    const e_2 = _arg_8;
                    console.error(e_2);
                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${e_2.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                    setPrefill(new Deferred$1(2, new FSharpResult$2(1, e_2.message)));
                    return singleton.Zero();
                });
            }));
        }
    }, [siblingSourceCode]);
    const title = (kind.tag === 1) ? "Nieuw EPC aanmaken" : "Nieuw dossier aanmaken";
    const dismissSibling = () => {
        if (crossCreate == null) {
            setCrossCreate(void 0);
        }
        else {
            const dossierCode_2 = crossCreate[0];
            setCrossCreate(void 0);
            RouterModule_nav(ofArray(Page$2__toUrl_2B594(dossierDetail, dossierCode_2.Value)), 1, 1);
        }
    };
    let crossCreateModal;
    const isOpen = crossCreate != null;
    const siblingKind_2 = map((tuple) => tuple[1], crossCreate);
    const promptMessage = (siblingKind_2 == null) ? "" : ((siblingKind_2.tag === 0) ? "Wil je voor dit dossier ook een asbestattest opstarten?" : "Wil je voor dit dossier ook een EPC opstarten?");
    crossCreateModal = MuiHelpers_createElement(Dialog, [["open", isOpen], ["onClose", (_arg_10, v) => {
        dismissSibling();
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", "Gekoppeld dossier"]]), (children = singleton_1(MuiHelpers_createElement(DialogContentText, [["children", promptMessage]])), MuiHelpers_createElement(DialogContent, [["children", Interop_reactApi.Children.toArray(Array.from(children))]])), (children_1 = ofArray([MuiHelpers_createElement(Button, [["color", "default"], ["onClick", (_arg_11) => {
        dismissSibling();
    }], ["children", "Nee"]]), MuiHelpers_createElement(Button, [["color", "primary"], ["variant", "contained"], ["onClick", (_arg_12) => {
        if (crossCreate != null) {
            const siblingKind_1 = crossCreate[1];
            const dossierCode_1 = crossCreate[0];
            setCrossCreate(void 0);
            RouterModule_nav(ofArray((siblingKind_1.tag === 0) ? Page$2__toUrl_2B594(dossierCreateFromSibling, dossierCode_1.Value) : Page$2__toUrl_2B594(epcCreateFromSibling, dossierCode_1.Value)), 1, 1);
        }
    }], ["children", "Ja"]])]), MuiHelpers_createElement(DialogActions, [["children", Interop_reactApi.Children.toArray(Array.from(children_1))]]))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])]);
    const stepper = (prefillValue) => createElement(CreateDossierStepperPage, {
        customerUrl: (arg_9) => Page$2__toUrl_2B594(customerDetail, arg_9),
        getCustomer: (customerCode) => {
            startImmediate(singleton.Delay(() => singleton.Bind(api.GetCustomer(customerCode), (_arg) => {
                const customer_1 = _arg;
                if (customer_1.tag === 1) {
                    const err = customer_1.fields[0];
                    console.error(err);
                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                    return singleton.Zero();
                }
                else {
                    setCustomer(customer_1.fields[0]);
                    return singleton.Zero();
                }
            })));
        },
        customers: customers,
        onCreateDossier: (dossierData) => ((comment) => ((floorplan) => ((cadastralRecords) => ((propertyOther) => ((sendMailToPartner) => ((onCompleted) => {
            startImmediate(singleton.Delay(() => singleton.TryFinally(singleton.Delay(() => singleton.TryWith(singleton.Delay(() => {
                toConsole(printf("%A"))(dossierData);
                return singleton.Bind(api.CreateDossier(dossierData, comment, sendMailToPartner), (_arg_3) => {
                    const result = _arg_3;
                    if (result.tag === 0) {
                        const dossierCode = result.fields[0];
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Een nieuw dossier is aangemaakt", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                        if (siblingSourceCode == null) {
                            setCrossCreate([dossierCode, (kind.tag === 1) ? (new DossierKind(0)) : (new DossierKind(1))]);
                            return singleton.Zero();
                        }
                        else {
                            RouterModule_nav(ofArray(Page$2__toUrl_2B594(dossierDetail, dossierCode.Value)), 1, 1);
                            return singleton.Zero();
                        }
                    }
                    else {
                        const err_3 = result.fields[0];
                        console.error(err_3);
                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_3}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                        return singleton.Zero();
                    }
                });
            }), (_arg_4) => {
                const e = _arg_4;
                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${e.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                console.error(e);
                return singleton.Zero();
            })), () => {
                onCompleted();
            })));
        })))))),
        onCreateCustomer: (customerData) => ((onCompleted_1) => {
            startImmediate(singleton.Delay(() => singleton.TryFinally(singleton.Delay(() => singleton.TryWith(singleton.Delay(() => singleton.Bind(api.CreateCustomer(customerData), (_arg_5) => {
                const result_1 = _arg_5;
                if (result_1.tag === 0) {
                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Een nieuwe klant is aangemaakt", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                    return singleton.Zero();
                }
                else {
                    const err_4 = result_1.fields[0];
                    console.error(err_4);
                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_4}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                    return singleton.Zero();
                }
            })), (_arg_6) => {
                const e_1 = _arg_6;
                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${e_1.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                console.error(e_1);
                return singleton.Zero();
            })), () => {
                onCompleted_1();
            })));
        }),
        customer: patternInput[0],
        setCustomer: setCustomer,
        partnersList: patternInput_4[0],
        setPartnerId: setPartnerId,
        dossierCreatePageSource: new DossierCreatePageSource(0),
        compensation: Compensation_get_DefaultCompensation(),
        kind: kind,
        prefill: prefillValue,
    });
    let body;
    const matchValue = [siblingSourceCode, patternInput_6[0]];
    let pattern_matching_result, draft_1;
    if (matchValue[0] != null) {
        if (matchValue[1].tag === 1) {
            pattern_matching_result = 1;
        }
        else if (matchValue[1].tag === 2) {
            if (matchValue[1].fields[0].tag === 1) {
                pattern_matching_result = 3;
            }
            else {
                pattern_matching_result = 2;
                draft_1 = matchValue[1].fields[0].fields[0];
            }
        }
        else if (matchValue[1].tag === 3) {
            pattern_matching_result = 4;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 0;
    }
    switch (pattern_matching_result) {
        case 0: {
            body = stepper(void 0);
            break;
        }
        case 1: {
            body = createElement("div", createObj(ofArray([["style", {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 4 + "rem",
            }], (elems_3 = [MuiHelpers_createElement(CircularProgress, [])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
            break;
        }
        case 2: {
            body = stepper(draft_1);
            break;
        }
        case 3: {
            body = stepper(void 0);
            break;
        }
        case 4: {
            body = stepper(void 0);
            break;
        }
    }
    return createElement(Page, {
        currentPage: currentPage,
        title: title,
        actions: [],
        children: [body, crossCreateModal],
    });
}

